import React from 'react';
import loadable from '@loadable/component';
import _isFunction from 'lodash/isFunction';

import SSRLoader from 'components/Loading/SSRLoader';
import isSSREnvironment from './isSSREnvironment';

export default function lazyLoad(
  loadFunc = () => {},
  fallback = <div>Loading...</div>
) {
  if (!_isFunction(loadFunc)) return () => null;
  const isSSREnv = isSSREnvironment();

  return loadable(loadFunc, {
    fallback: isSSREnv ? <SSRLoader /> : fallback,
    ssr: false
  });
}
